/* Naevii Dad Shirt — scroll reveal + how-to stepper + delivery tracker */
(function () {
  'use strict';

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.dad-reveal:not([data-reveal-bound])');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { el.setAttribute('data-reveal-bound', '1'); io.observe(el); });
  }

  function initSteppers(root) {
    var steppers = (root || document).querySelectorAll('[data-dad-stepper]:not([data-stepper-bound])');
    steppers.forEach(function (el) {
      el.setAttribute('data-stepper-bound', '1');
      var track = el.querySelector('[data-stepper-track]');
      var slides = el.querySelectorAll('[data-stepper-slide]');
      var dots = el.querySelectorAll('[data-stepper-dot]');
      var captions = el.querySelectorAll('[data-stepper-caption]');
      var bar = el.querySelector('[data-stepper-bar]');
      var prev = el.querySelector('[data-stepper-prev]');
      var next = el.querySelector('[data-stepper-next]');
      var count = slides.length;
      if (!track || count === 0) return;
      var interval = parseInt(el.getAttribute('data-interval'), 10) || 4000;
      var active = 0, timer = null, paused = false, inView = false, startX = null;

      function render() {
        track.style.transform = 'translateX(-' + (active * 100) + '%)';
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
        captions.forEach(function (c, i) { c.style.display = i === active ? '' : 'none'; });
        if (bar) { bar.style.animation = 'none'; void bar.offsetWidth;
          bar.style.animation = paused ? 'none' : ('dad-stepper-progress ' + (interval / 1000) + 's linear forwards'); }
      }
      function go(dir) { active = (active + dir + count) % count; render(); }
      function to(i) { active = i; render(); }
      function start() { stop(); if (!inView || paused) return; timer = setInterval(function () { active = (active + 1) % count; render(); }, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (prev) prev.addEventListener('click', function () { go(-1); start(); });
      if (next) next.addEventListener('click', function () { go(1); start(); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { to(i); start(); }); });
      el.addEventListener('mouseenter', function () { paused = true; stop(); });
      el.addEventListener('mouseleave', function () { paused = false; render(); start(); });
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; paused = true; stop(); }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        startX = null; paused = false; render(); start();
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting; if (inView) start(); else stop();
        }, { threshold: 0.3 }).observe(el);
      } else { inView = true; start(); }
      render();
    });
  }

  function initTrackers(root) {
    var trackers = (root || document).querySelectorAll('[data-dad-tracker]:not([data-tracker-bound])');
    var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    function addBusinessDays(date, days) {
      var d = new Date(date), added = 0;
      while (added < days) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
      return d;
    }
    function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
    trackers.forEach(function (el) {
      el.setAttribute('data-tracker-bound', '1');
      var mins = parseInt(el.getAttribute('data-minutes'), 10) || 10;
      var shipDays = parseInt(el.getAttribute('data-ship-days'), 10) || 1;
      var minDays = parseInt(el.getAttribute('data-min-days'), 10) || 5;
      var maxDays = parseInt(el.getAttribute('data-max-days'), 10) || 7;
      var now = new Date();
      var ship = addBusinessDays(now, shipDays);
      var delMin = addBusinessDays(now, minDays);
      var delMax = addBusinessDays(now, maxDays);
      var dP = el.querySelector('[data-date-purchased]');
      var dS = el.querySelector('[data-date-ship]');
      var dD = el.querySelector('[data-date-deliver]');
      var dByEl = el.querySelector('[data-deliver-by]');
      if (dP) dP.textContent = fmt(now);
      if (dS) dS.textContent = fmt(ship);
      if (dD) dD.textContent = fmt(delMin) + ' - ' + fmt(delMax);
      if (dByEl) dByEl.textContent = fmt(delMax);

      var clock = el.querySelector('[data-tracker-clock]');
      var total = mins * 60, left = total;
      function tick() {
        var m = Math.floor(left / 60), s = left % 60;
        if (clock) clock.textContent = m + ':' + (s < 10 ? '0' + s : s);
        left = left <= 0 ? total : left - 1;
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function initAll(root) { initReveal(root); initSteppers(root); initTrackers(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();
